var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app_container container"},[_c('div',{staticClass:"entrance-title"},[_vm._v("浙江干部教育培训数智化管理平台")]),_c('butn',{staticClass:"enterBtn",attrs:{"btntype":"primary","title":"点击进入"},on:{"click":_vm.enterClick}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }